var tooltip=function(){var id='tt';var top=3;var left=3;var maxw=300;var speed=10;var timer=20;var endalpha=95;var alpha=0;var tt,t,c,b,h;var ie=document.all?true:false;return{show:function(v,w){if(tt==null){tt=document.createElement('div');tt.setAttribute('id',id);t=document.createElement('div');t.setAttribute('id',id+'top');c=document.createElement('div');c.setAttribute('id',id+'cont');b=document.createElement('div');b.setAttribute('id',id+'bot');tt.appendChild(t);tt.appendChild(c);tt.appendChild(b);document.body.appendChild(tt);tt.style.opacity=0;tt.style.filter='alpha(opacity=0)';document.onmousemove=this.pos;}
tt.style.display='block';c.innerHTML=v;tt.style.width=w?w+'px':'auto';if(!w&&ie){t.style.display='none';b.style.display='none';tt.style.width=tt.offsetWidth;t.style.display='block';b.style.display='block';}
if(tt.offsetWidth>maxw){tt.style.width=maxw+'px'}
h=parseInt(tt.offsetHeight)+top;clearInterval(tt.timer);tt.timer=setInterval(function(){tooltip.fade(1)},timer);},pos:function(e){var u=ie?event.clientY+document.documentElement.scrollTop:e.pageY;var l=ie?event.clientX+document.documentElement.scrollLeft:e.pageX;tt.style.top=(u-h)+'px';tt.style.left=(l+left)+'px';},fade:function(d){var a=alpha;if((a!=endalpha&&d==1)||(a!=0&&d==-1)){var i=speed;if(endalpha-a<speed&&d==1){i=endalpha-a;}else if(alpha<speed&&d==-1){i=a;}
alpha=a+(i*d);tt.style.opacity=alpha*.01;tt.style.filter='alpha(opacity='+alpha+')';}else{clearInterval(tt.timer);if(d==-1){tt.style.display='none'}}},hide:function(){clearInterval(tt.timer);tt.timer=setInterval(function(){tooltip.fade(-1)},timer);}};}();

var map;

var lokacijeCache = {};

var overlay = {
    'lokacije': {},
    'podlokacije': {}
};

var latlngbounds = new google.maps.LatLngBounds();

var options = {
    'lokacije': {
        'normal': {
            'strokeColor': '#777777',
            'strokeOpacity': 0.5,
            'fillColor': '#0090ff',
            'fillOpacity': 0.03
        },
        'active': {
            'strokeOpacity': 0.75,
            'fillOpacity': 0.3
        }
    },
    'podlokacije': {
        'normal': {
            'strokeColor': '#777777',
            'strokeOpacity': 0.3,
            'fillColor': '#0090ff',
            'fillOpacity': 0
        },
        'active': {
            'strokeOpacity': 0.75,
            'fillOpacity': 0.75
        }
    },
    'lokacijeCached': false
};

function initialize() {
    if(!document.getElementById('gmap')) {
        return;
    }

    var uluru = new google.maps.LatLng(44.802532, 20.435469);

    map = new google.maps.Map(document.getElementById('gmap'), {
        zoom: 11,
        center: uluru,
        disableDefaultUI: true,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        navigationControl: false,
        mapTypeControl: false,
        scaleControl: false,
        draggable: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    map.addListener('tilesloaded', function(e) {
        drawMap();
    });
}

function makeActive(obj, hover) {
    obj.setOptions({
        strokeOpacity: options.podlokacije.active.strokeOpacity,
        fillOpacity: options.podlokacije.active.fillOpacity
    });

    if (!hover) {
        obj.setOptions({
            active: true
        });
    }

    overlay.lokacije[obj.parent_id].setOptions({
        strokeOpacity: options.lokacije.active.strokeOpacity,
        fillOpacity: options.lokacije.active.fillOpacity
    });
}

function makeInactive(obj) {
    obj.setOptions({
        strokeOpacity: options.podlokacije.normal.strokeOpacity,
        fillOpacity: options.podlokacije.normal.fillOpacity,
        active: false,
    });

    if (typeof overlay.lokacije[obj.parent_id] != 'undefined') {
        overlay.lokacije[obj.parent_id].setOptions({
            strokeOpacity: options.lokacije.normal.strokeOpacity,
            fillOpacity: options.lokacije.normal.fillOpacity
        });
    }
}

function populateSublocationSelect(parentId) {
    if (!options.lokacijeCached) {
        $.ajaxSetup({
            async: false
        });

        $.getJSON('/local-api/locations/all/', function(lokacije) {
            lokacijeCache = lokacije;

            options.lokacijeCached = true;

            $.ajaxSetup({
                async: true
            });
        });
    }

    $('#sublocation-select')
        .find('option')
        .remove();

    for (var key in lokacijeCache.podlokacije) {
        var obj = lokacijeCache.podlokacije[key];
        console.log(obj, parentId)

        if (obj['parent_id'] != parentId) {
            continue;
        }

        $('#sublocation-select')
            .find('option')
            .end()
            .append(`<option value="${obj['id']}">${obj['ime']}</option>`);
    }

    $("#sublocation-select").html($('#sublocation-select option').sort(function(x, y) {
        return $(x).text() < $(y).text() ? -1 : 1;
    }));
    let message = $('#sublocation-select').data('message');
    $('#sublocation-select').prepend('<option value="" disabled selected>'+message+'</option>');
}

function drawMap() {
    if (!options.lokacijeCached) {
        $.getJSON('/local-api/locations/all/', function(lokacije) {
            lokacijeCache = lokacije;

            options.lokacijeCached = true;

            drawMap();
        });
    } else {
        for (var key in overlay.podlokacije) {
            var obj = overlay.podlokacije[key];

            makeInactive(obj);
        }

        $('input[name=locations\\[\\]]:checked').each(function() {
            var id = $(this).val();

            var polyId = (lokacijeCache.podlokacije[id]['parent_location'] == 0
                ? lokacijeCache.podlokacije[id]['id']
                : lokacijeCache.podlokacije[id]['parent_location']);

            makeActive(overlay.podlokacije[polyId]);
        });
    }
}

function shineOut(id) {
    if (overlay.podlokacije[id]['active']) {
        overlay.podlokacije[id]['active'] = false;

        makeInactive(overlay.podlokacije[id]);

        $(overlay.podlokacije[id]['similar']).each(function() {
            $('#location-' + this).prop('checked', false).parent().hide();
        });
    } else {
        overlay.podlokacije[id]['active'] = true;

        makeActive(overlay.podlokacije[id]);

        $(overlay.podlokacije[id]['similar']).each(function() {
            $('#location-' + this).prop('checked', true).parent().show();
        });
    }

    refreshResults();
}

$().ready(function() {
    initialize();

    $('#sorting-controller').change(function(){
        $('#sorting').val($(this).val());

        $('#search-form').submit();
    });

    $('.search-property__form__bottom__detail-search p').click(function(){
        $('.seaarch-property__form__middle').toggle('fast');
    });

    $('#location-select').on('change', function(){
        populateSublocationSelect($(this).val());
    });

    $('#sublocation-select').on('change', function(){
        $('#location-' + $(this).val()).prop('checked', true).parent().show();

        drawMap();
    });

    $('input[name=locations\\[\\]]:checked').each(function() {
        $(this).parent().show();
    });

    $('input[name=locations\\[\\]]').change(function() {
        drawMap();

        if(!$(this).prop('checked')) {
            $(this).parent().hide();
        }

        refreshResults();
    });

    $('#search-form input, #search-form select').change(function() {
        refreshResults();
    });

    if(document.getElementById('gmap')) {
        $.getJSON('/local-api/locations/', function(lokacije) {
            $(lokacije['lokacije']).each(function() {
                var allLokacijeCoords = [];

                var id = this.id;

                if(this['gmap'].length > 0) {
                    $(this['gmap']).each(function() {
                        var tmpLatLng = new google.maps.LatLng(this[0], this[1]);

                        allLokacijeCoords.push(tmpLatLng);

                        latlngbounds.extend(tmpLatLng);
                    });
                }

                overlay.lokacije[id] = new google.maps.Polygon({
                    paths: allLokacijeCoords,
                    strokeColor: options.lokacije.normal.strokeColor,
                    strokeWeight: 2,
                    clickable: false,
                    strokeOpacity: options.lokacije.normal.strokeOpacity,
                    fillColor: options.lokacije.normal.fillColor,
                    fillOpacity: options.lokacije.normal.fillOpacity
                });

                overlay.lokacije[id].setMap(map);
            });

            $(lokacije['podlokacije']).each(function() {
                var allPodlokacijeCoords = [];

                var tooltipText = this.tooltip;

                var similar = this.similar;

                var id = this.id;

                var parent_id = this.parent_id;

                if(this['gmap'].length > 0) {
                    $(this['gmap']).each(function() {
                        var tmpLatLng = new google.maps.LatLng(this[0], this[1]);

                        allPodlokacijeCoords.push(tmpLatLng);
                    });
                }

                overlay.podlokacije[id] = new google.maps.Polygon({
                    active: false,
                    fillColor: options.podlokacije.normal.fillColor,
                    fillOpacity: options.podlokacije.normal.fillOpacity,
                    id: id,
                    parent_id: parent_id,
                    paths: allPodlokacijeCoords,
                    similar: similar,
                    strokeColor: options.podlokacije.normal.strokeColor,
                    strokeOpacity: options.podlokacije.normal.strokeOpacity,
                    strokeWeight: 2,
                });

                overlay.podlokacije[id].setMap(map);

                google.maps.event.addListener(overlay.podlokacije[id], 'mouseover', function() {
                    makeActive(this, true);

                    tooltip.show(tooltipText);
                });

                google.maps.event.addListener(overlay.podlokacije[id], 'mouseout', function() {
                    if (!this['active']) makeInactive(this);

                    tooltip.hide();
                });

                google.maps.event.addListener(overlay.podlokacije[id], 'click', function() {
                    shineOut(this.id);
                });
            });
        });

        refreshResults();
    }
});

function refreshResults() {
    $.ajax({
        type: 'GET',
        url: '/local-api/search-count',
        data: $('#search-form').serialize(),
        success: function(msg) {
            if (msg['count'] == 0) {
                $('#search-button').css('opacity', '0.5');

                $('#search-button').css('cursor', 'default');

                $('#search-button').val(msg['message']);

                $('#search-button').unbind('click');

            } else {
                $('#search-button').css('opacity', '1');

                $('#search-button').css('cursor', 'pointer');

                $('#search-button').val(msg['message']);

                $('.searchButton').click(function() {
                    $('#' + $('.vrsta:checked').val() + '_form').submit();
                });
            }
        }
    });
}
